import { render, staticRenderFns } from "./SlDetails.vue?vue&type=template&id=2d894716&scoped=true&"
import script from "./SlDetails.vue?vue&type=script&lang=js&"
export * from "./SlDetails.vue?vue&type=script&lang=js&"
import style0 from "./SlDetails.vue?vue&type=style&index=0&id=2d894716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d894716",
  null
  
)

export default component.exports